import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import cn from 'classnames';
import React from 'react';

import type { ThemedComponent } from '../../types/types';

import type { RichText as Props } from './rich-text.props';
import { themes } from './rich-text.props';
import { renderOptions } from './rich-text-renderer-options';

const RichText: ThemedComponent<Props, typeof themes> = ({
  content,
  theme,
}) => (
  <div className={cn('rich-text', { 'rich-text--small-paragraphs': theme })}>
    {content ? documentToReactComponents(content, renderOptions) : null}
  </div>
);

RichText.themes = themes;

export default RichText;
